export default __webpack_public_path__ + "static/media/002-tongue-depressor-orange.457f83f8.svg";